import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      show: false,
      timeout: 6000,
      message: "",
      color: "green",
      path: "peminjaman",
      buttonColor: "pink"
    }, 
    ruangKosong: "",
    message: "Chips Ahoy!"
  },
  mutations: {
    f(state, msg){
      state.message = msg
    },
    SET_SNACKBAR(state, show){
      state.snackbar.show = show
      setTimeout(() => {
        state.snackbar.show = false
        state.snackbar.message = ""
        state.snackbar.path = ""
      }, state.snackbar.timeout);
    },
    SET_MSG_SNACKBAR(state, msg){
      state.snackbar.message = msg
    },
    SET_PATH_SNACKBAR(state, path){
      state.snackbar.path = path
    },
    SET_SNACKBAR_DETAIL(state, show, message, path, timeout, color, buttonColor){
      state.snackbar.show = show
      state.snackbar.message = message
      state.snackbar.path = path
      state.snackbar.color = color
      state.snackbar.buttonColor = buttonColor
      state.snackbar.timeout = timeout
    },
    SET_RUANG_KOSONG(state, rk){
      state.ruangKosong = rk
    }
  },
  actions: {
    fetchMsgSnackbar(context, msg){
      context.commit('SET_MSG_SNACKBAR', msg)
    },
    fetchPathSnackbar(context, path){
      context.commit('SET_PATH_SNACKBAR', path)
    },
    fetchSnackbar(context, show, message, path){
      context.commit('SET_SNACKBAR', show, message, path)
    },
    fetchSnackbarDetail(context, show, message, path, timeout, color, buttonColor){
      context.commit('SET_SNACKBAR_DETAIL', show, message, path, timeout, color, buttonColor)
    },
    fetchRuangKosong(context, rk){
      context.commit('SET_RUANG_KOSONG', rk)
    }

  },
  getters: {
    getMsg(state){
      return state.message
    },
    snackbar(state){
      return state.snackbar
    },
    ruangKosong(state){
      return state.ruangKosong
    }
  }

  
})
